import { render } from "./TabelaPrecoModal.vue?vue&type=template&id=34f349a9&scoped=true&ts=true"
import script from "./TabelaPrecoModal.vue?vue&type=script&lang=ts"
export * from "./TabelaPrecoModal.vue?vue&type=script&lang=ts"

import "./TabelaPrecoModal.vue?vue&type=style&index=0&id=34f349a9&lang=css&scoped=true"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f349a9"]])

export default __exports__